import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';
import PropTypes from 'prop-types';

class SecondaryButton extends React.Component {

  render() {

    const { classes, onClick, startIcon, endIcon, size, dataTest, disabled, compact, shortcut } = this.props;

    return (
      <Button
        aria-keyshortcuts={shortcut}
        disabled={disabled}
        data-test={dataTest}
        variant="contained"
        onClick={onClick}
        endIcon={endIcon}
        startIcon={startIcon}
        className={classes.secondaryButton}
        style={size === "wide" ?
          { width: '200px' }
          :
          compact ?
            { padding: '2px 12px' }
            :
            {}}>
        {this.props.children}
      </Button>
    );
  }
}

SecondaryButton.defaultProps = {
  size: "standard",
  disabled: false,
  compact: false
};

SecondaryButton.propTypes = {
  shortcut: PropTypes.string,
  disabled: PropTypes.bool,
  dataTest: PropTypes.string,
  onClick: PropTypes.func,
  endIcon: PropTypes.object,
  compact: PropTypes.bool,
  size: PropTypes.oneOf(["standard", "wide"]),
  startIcon: PropTypes.object,
  classes: PropTypes.object
};

export default withStyles(styles)(SecondaryButton);